import { CraneDriverView, Permission } from "src/store/api/generatedApi";

export const CRANE_DRIVER_PERMISSIONS: Permission[] = ["crane_driver"];

export const CRANE_HEAT_RECIPE_VIEW_PERMISSIONS: Permission[] = [
  "crane_driver",
  "crane_supervisor",
  "crane_supervisor_viewer",
];

export const cranePagesEnabled = (
  craneDriverView: CraneDriverView | undefined
): boolean => craneDriverView !== undefined && craneDriverView !== "none";
